import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";


const PortfolioList = [
    {
        image: 'image-2',
        category: 'Brand identity',
        title: ' Logo and branding for Atcom GT'
    },
    {
        image: 'image-1',
        category: 'Graphic design',
        title: ' Book designs for Vesna Dedić'
    },
    {
        image: 'image-3',
        category: 'Design/Publishing',
        title: ' HTML-5 interactive content for Cineplexx'
    },
    {
        image: 'image-5',
        category: 'Graphic design',
        title: ' Book designs for Čarobna knjiga'
    },
    {
        image: 'image-4',
        category: 'Brand identity',
        title: ' Brand design for NextLinks'
    },
    {
        image: 'image-6',
        category: 'Graphic design',
        title: ' Brand identity system for Češalj & Makaze'
    }
]

class Portfolio extends Component{
    render(){
        let title = 'Our work',
        description = 'Selected projects delivered as independent contractor engagements — clear scope, accountable delivery, and production-ready results.';
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-slick-activation mt--70 mt_sm--40">
                        <Slider {...portfolioSlick2}>
                            {PortfolioList.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <div className={`thumbnail ${value.image}`}></div>
                                        <div className={`bg-blr-image ${value.image}`}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>{value.category}</p>
                                            <h4><a href="/portfolio">{value.title}</a></h4>
                                            <div className="portfolio-button">
                                                <a className="rn-btn" href="/portfolio">View portfolio</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;
